import React, { useEffect } from "react";
import "./main-page.scss";
import Avatar from "../../../../components/img/no_avatar.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCheckPaidInvoicesClientSelector } from "../../../../selectors/users-selectors";
import UnpaidInvoice from "../../modal/unpaid-invoice";

const MainPage = () => {
  const user = useSelector((state) => state.auth.user);
  const checkedInvoices = useSelector((state) =>
    getCheckPaidInvoicesClientSelector(state)
  );
  const loadingUnpaid = useSelector((state) => state.auth.loadingUnpaid);

  useEffect(() => {
    document.title = `${user?.last_name} ${user?.first_name}` || "Главная";
  }, [user]);

  return (
    <div className="mainWrapper">
      <h2>Главная</h2>
      <div className="mainContainer">
        <div className="headerMain">
          <h3>Дети</h3>

          <div className="boxChildItemContainer">
            {user.general.children.length > 0 ? (
              user.general.children.map((item) => (
                <div className="boxChildItem" key={item.id}>
                  <Link to={`/client/child/${item.id}`}>
                    <div
                      className="avatarChildClient"
                      style={{
                        backgroundImage: `url(${
                          item.avatar?.full_url || Avatar
                        })`,
                      }}
                    />
                  </Link>
                  <div className="nameChildBox">
                    <h4>
                      <Link to={`/client/child/${item.id}`}>
                        {item.last_name} {item.first_name}
                      </Link>
                    </h4>
                  </div>
                  <h5>
                    {item.age} {item.age > 4 ? "лет" : "года"}
                  </h5>
                </div>
              ))
            ) : (
              <h3>Отсутсвуют</h3>
            )}
          </div>
        </div>
        <div className="eventMain">
          <h3>События</h3>
          {/*          <div className="eventMainBlock">
            <p>
              Ирина, вы создали, но пока не оплатили занятия для Лопухин
              Анатолий. К оплате...
            </p>
            <div className="eventMainBlockFooter">
              <span>Робот</span>
              <span>16.08.2020 12:30</span>
            </div>
          </div>*/}
          <h4>Нет активных событий</h4>
        </div>
      </div>
      {checkedInvoices && loadingUnpaid && (
        <UnpaidInvoice
          open={checkedInvoices && loadingUnpaid}
          id={checkedInvoices.id}
        />
      )}
    </div>
  );
};

export default MainPage;
